import React from 'react'
import api, { AppUser } from 'api'

export default class ResetPasswordForm extends React.PureComponent<{ user: AppUser }> {
	render() {
		let data = { ...this.props.user, userId: this.props.user.id }
		return <div />
	}
}



// WEBPACK FOOTER //
// ./src/modules/User/ResetPasswordForm.tsx